

export default()=> ({
   loading:false,
   employmentForm:{},
});